module.exports = __webpack_public_path__ + "static/img/16.370062b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/16.png
// module id = NnEm
// module chunks = 0